import { useMemo, useState } from 'react'
import { DataGrid } from '@/components/blocks/data-grid'
import { applyTableState, useTableState } from '@/components/blocks/data-table'
import { GameConfigShell } from '@/components/config/GameConfigShell'
import { ENTRY_COLUMNS } from '@/components/config/Grids'
import { MATCHMAKING } from '@/fixtures'
import type { ConfigEntry } from '@/models'

/* Still on fixtures: this section has no table of its own yet. When it gets
 * one, the controller hands rows down as props and only the two lines that
 * reach for MATCHMAKING change. */
export default function GameConfigMatchmaking() {
  const { state, setState } = useTableState({ pageSize: 50 })
  const [rows, setRows] = useState<ConfigEntry[]>(MATCHMAKING)
  const [dirty, setDirty] = useState<Set<string>>(new Set())

  const view = useMemo(() => applyTableState(rows, ENTRY_COLUMNS, state), [rows, state])

  const handleCellChange = (row: ConfigEntry, key: string, value: string) => {
    setRows((previous) =>
      previous.map((entry) => (entry.key === row.key ? { ...entry, [key]: value } : entry)),
    )
    setDirty((previous) => new Set(previous).add(row.key))
  }

  return (
    <GameConfigShell
      section="Matchmaking"
      description="Queue windows and rating bands."
      dirtyCount={dirty.size}
      onRevert={() => {
        setRows(MATCHMAKING)
        setDirty(new Set())
      }}
    >
      <DataGrid
        columns={ENTRY_COLUMNS}
        rows={view.rows}
        total={view.total}
        state={state}
        onStateChange={setState}
        rowKey={(row) => row.key}
        onCellChange={handleCellChange}
        noun="entries"
        paginate={false}
        maxHeight={560}
      />
    </GameConfigShell>
  )
}
